module.exports = __webpack_public_path__ + "media/electronic_components_sourcing/digikey-653b69dc.png";